import { hasPermission } from '@/utils/permissions'

export default {
  inserted(el, binding) {
    const buttonKeys = binding.value
    if (buttonKeys) {
      const key = hasPermission(buttonKeys)
      if (!key) {
        el.remove() // 删除按钮
      }
    } else {
      throw new Error(`缺少唯一指令:${el}\n${buttonKeys}`)
    }
  },
}
